import React from "react";
import "./SearchResult.css";

interface Highlight {
    page: number;
    text: string;
}

interface SearchResultProps {
    documentName: string;
    fileType: string;
    author: string;
    lastModified: string;
    highlights: Highlight[];
}
function SearchResult({
    documentName = "",
    fileType = "",
    author = "",
    lastModified = "",
    highlights = [],
}: SearchResultProps) {
    return (
        <div className="search-result">
            <h3>{documentName}</h3>
            <p>
                Last modified by
                {author} on {lastModified}
            </p>
            <div className="file-type">{fileType}</div>
            <ul>
                {highlights.map((highlight, index) => (
                    <li key={index}>
                        <div className="search-result-findings">
                            <div className="search-result-finding-text">
                                {highlight.text}
                            </div>
                            <div className="search-result-finding-page">
                                Page {highlight.page}
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default SearchResult;
